/**
 * Portal target for overlay UI. Rendering there keeps a popup, dialog, or menu
 * outside any ancestor with `overflow: hidden` that would otherwise clip it.
 */
export const getPortalRoot = (): Element =>
	document.querySelector("#root-portal") ?? document.body;
